import { createFileRoute } from '@tanstack/react-router'

import { ListPageHeader } from '@/components/common/ListPageHeader'
import { PostEditor } from '@/components/retail/cms/post-editor'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/retail/posts/new')(
    {
        component: NewPostPage,
    },
)

function NewPostPage() {
    const { hasPermission } = useAuth()
    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader title={m.cmsPost_new_title()} />
            <PostEditor canWrite={hasPermission('shop_content.write')} />
        </div>
    )
}
